var React = require('react');

function Left (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.5 22.1064L12.2071 21.3993L2.30761 11.4998L12.2071 1.60035L11.5 0.893242L1.60051 10.7927L0.893399 11.4998L1.60051 12.2069L11.5 22.1064Z","fill":"#202020"}));
}

Left.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = Left;

Left.default = Left;
